console.log("Auto GWP enabled");

const autoGWPenabled = true;
const gwp_variant_id = "41905182474276";
const gwp_handle = "precious-metals-hair-adornment-box";
const gwp_sku = "LU-ADVCAL-PreciousMetals";
const excluded_variant_ids = ["30997677178916", "40720482828324", "32589565427748", "30997677375524", "30997677342756", "30997677309988", "30997677277220", "30997677211684"];
const THRESHOLD = 300;
const gwpData = {
    sku: "LU-ADVCAL-PreciousMetals",
    name: "Precious Metals Hair Adornment Box",
    price: 0, // Free
    compareAtPrice: 4000, // Optional, for displaying the original price
    vendor: "Luxy Hair",
    category: "Luxy Hair Accessories",
    url: "/products/precious-metals-hair-adornment-box",
    image: "//www.luxyhair.com/cdn/shop/files/Luxy_PreciousMetals_045_MAIN_V1_400x_crop_center.jpg?v=1730083237"
};

const items = {
    id: gwp_variant_id,
    quantity: 1,
    properties: {
        '_Gift Discount': 'Free Gift'
    }
};

let lastAdjustedSubtotal = null;

document.addEventListener("DOMContentLoaded", () => {
    initAutoGWPctas();

    // Initial check for cart page
    if (window.location.pathname === '/cart') {
        console.log("Running Auto GWP Check on Cart Page Load");
        setTimeout(() => {
            checkAndApplyGWPLogic();
        }, 1000);
    }

    // Detect cart drawer updates and reapply logic
    observeCartDrawerChanges();
    // Run GWP check when cart is opened
    document.querySelectorAll('[data-module-cart-link]').forEach(link => {
        link.addEventListener('click', () => {
            console.log("Cart link clicked. Running Auto GWP Check...");
            setTimeout(() => {
                checkAndApplyGWPLogic();
            }, 500);
        });
    });
});

function initAutoGWPctas() {
    // Hook into add-to-cart buttons
    if ($("button[module-add-to-cart]").length > 0) {
        console.log("Auto GWP CTAs loaded");
        const gwpAdd2Cart = document.querySelectorAll("button[module-add-to-cart]");
        gwpAdd2Cart.forEach(function (button) {
            button.addEventListener('click', () => {
                if (window.location.pathname === '/cart') {
                    checkAndApplyGWPLogic();
                } else {
                    setTimeout(() => {
                        checkAndApplyGWPLogic();
                    }, 1500);
                }
            });
        });
    }

    // Hook into quantity change links
    if ($("a[data-local-increment], a[data-local-decrement]").length > 0) {
        console.log("Auto GWP quantity links loaded");
        const cartQuantityLinks = document.querySelectorAll("a[data-local-increment], a[data-local-decrement]");
        cartQuantityLinks.forEach(function (link) {
            link.addEventListener('click', () => {
                console.log("Quantity updated. Checking GWP...");
                setTimeout(() => {
                    checkAndApplyGWPLogic();
                }, 1500);
            });
        });
    }
}

// Detect cart drawer changes via MutationObserver
function observeCartDrawerChanges() {
    const cartDrawerContainer = document.querySelector("div[data-module-cart-drawer-items]");
    if (cartDrawerContainer) {
        const observer = new MutationObserver(() => {
            console.log("Cart drawer updated. Checking GWP...");
            setTimeout(() => {
                checkAndApplyGWPLogic();
            }, 1000);
        });

        observer.observe(cartDrawerContainer, { childList: true, subtree: true });
    }
}

async function checkAndApplyGWPLogic() {
    const adjustedSubtotal = await getStableAdjustedSubtotal();

    if (adjustedSubtotal === null) {
        console.error("Failed to stabilize adjusted subtotal. Skipping GWP logic.");
        return;
    }

    const isGwpInCart = await checkGwpInCart();

    if (adjustedSubtotal !== lastAdjustedSubtotal) {
        console.log("Adjusted Subtotal Changed:", adjustedSubtotal);
        lastAdjustedSubtotal = adjustedSubtotal;

        if (isGwpInCart) {
            if (adjustedSubtotal < THRESHOLD) {
                console.log("Adjusted subtotal below threshold. Removing GWP...");
                removeGwpFromCart();
            } else {
                console.log("GWP already in cart and subtotal meets threshold.");
            }
        } else {
            if (adjustedSubtotal >= THRESHOLD) {
                console.log("Adjusted subtotal meets threshold. Adding GWP...");
                addGwpToCart();
            } else {
                console.log("Adjusted subtotal below threshold. No action needed.");
            }
        }
    } else {
        console.log("No change in adjusted subtotal. Skipping GWP logic.");
    }
}

async function getStableAdjustedSubtotal(retries = 5, delay = 500) {
    let lastSubtotal = null;

    for (let attempt = 1; attempt <= retries; attempt++) {
        const adjustedSubtotal = await getAdjustedSubtotal();
        if (adjustedSubtotal !== 0) {
            return adjustedSubtotal;
        }

        console.log(`Retrying subtotal fetch (${attempt}/${retries})...`);
        await new Promise(resolve => setTimeout(resolve, delay));

        if (lastSubtotal === adjustedSubtotal) {
            return adjustedSubtotal;
        }
        lastSubtotal = adjustedSubtotal;
    }

    return null;
}

async function getAdjustedSubtotal() {
    try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        const subtotalInDollars = cart.items_subtotal_price / 100;

        const excludedTotal = cart.items
            .filter(item => excluded_variant_ids.includes(item.variant_id.toString()))
            .reduce((total, item) => total + (item.line_price / 100), 0);

        const adjustedSubtotal = subtotalInDollars - excludedTotal;
        console.log("Adjusted Subtotal:", adjustedSubtotal);

        return adjustedSubtotal;
    } catch (error) {
        console.error("Failed to fetch adjusted subtotal:", error);
        return 0;
    }
}

async function checkGwpInCart() {
    try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        // Check if the free GWP exists in the cart
        return cart.items.some(item =>
            item.variant_id.toString() === gwp_variant_id &&
            item.properties &&
            item.properties["_Gift Discount"] === "Free Gift"
        );
    } catch (error) {
        console.error("Failed to check if GWP is in cart:", error);
        return false;
    }
}

function addGwpToCart() {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(items),
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            console.log("GWP added to cart:", result);
            if (window.location.pathname === '/cart') {
                window.location.reload();
            } else {
                reloadSideCartGWP("add", gwpData);
            }
        },
        error: function (error) {
            console.error("Failed to add GWP to cart:", error);
        }
    });
}

function removeGwpFromCart() {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function (cart) {
            // Find the free GWP item based on its properties
            const freeGwpItem = cart.items.find(
                item =>
                    item.variant_id.toString() === gwp_variant_id &&
                    item.properties &&
                    item.properties["_Gift Discount"] === "Free Gift"
            );

            if (freeGwpItem) {
                const freeGwpKey = freeGwpItem.key;

                // Remove the free GWP item using its unique `key`
                $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    data: JSON.stringify({
                        id: freeGwpKey,
                        quantity: 0
                    }),
                    contentType: 'application/json',
                    dataType: 'json',
                    success: function (result) {
                        console.log("Free GWP removed from cart:", result);
                        if (window.location.pathname === '/cart') {
                            window.location.reload();
                        } else {
                            reloadSideCartGWP("remove", gwpData);
                        }
                    },
                    error: function (error) {
                        console.error("Failed to remove free GWP from cart:", error);
                    }
                });
            } else {
                console.error("Free GWP item not found in the cart.");
            }
        },
        error: function (error) {
            console.error("Failed to fetch cart data:", error);
        }
    });
}

function reloadSideCartGWP(action, gwpData) {
    const cartDrawerContainer = document.querySelector("div[data-module-cart-drawer-items]");
    if (!cartDrawerContainer) {
        console.error("Cart drawer container not found.");
        return;
    }

    const items = Array.from(cartDrawerContainer.querySelectorAll(`[data-item-sku="${gwpData.sku}"]`));
    const existingGwpItem = items.find(item => {
        const itemPrice = item.getAttribute("data-item-price");
        return itemPrice === "0";
    });



    if (action === "add") {
        if (!existingGwpItem) {
            const gwpHTML = `
                <div class="cart-drawer-item with--close" data-item-sku="${gwpData.sku}" data-item-name="${gwpData.name}" data-item-price="${gwpData.price}" data-item-vendor="${gwpData.vendor}" data-item-category="${gwpData.category}" data-item-quantity="1" data-gwp="true">
                  <div class="flex line-item">
                    <div class="line-item-image">
                      <a href="${gwpData.url}" class="image-container">
                        <img src="${gwpData.image}" class="cart-drawer-item-image" alt="${gwpData.name}">
                      </a>
                    </div>
                    <div class="line-item-text">
                      <div class="drawer-line-item-top">
                        <h3 class="local--heading">
                          <a href="${gwpData.url}" class="cart-drawer-product-link">${gwpData.name}</a>
                        </h3>
                        <div class="cart-drawer-item-price flex">
                          <div class="local--price state--on-sale">${gwpData.price === 0 ? "FREE" : `$${(gwpData.price / 100).toFixed(2)}`}</div>
                          ${gwpData.compareAtPrice ? `<div class="local--compare-price mr-2">$${(gwpData.compareAtPrice / 100).toFixed(2)}</div>` : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            `;
            cartDrawerContainer.insertAdjacentHTML("afterbegin", gwpHTML);
            console.log("Free GWP added to cart drawer.");
        } else {
            console.log("Free GWP already exists in the cart drawer.");
        }
    } else if (action === "remove") {
        if (existingGwpItem) {
            existingGwpItem.remove();
            console.log("Free GWP removed from cart drawer.");
        } else {
            console.log("Free GWP not found in the cart drawer.");
        }
    } else {
        console.error("Invalid action specified. Use 'add' or 'remove'.");
    }
}